/**
 * Возвращает первую буквенно-цифровую литеру строки в верхнем регистре —
 * подходит для отрисовки внутри Avatar.
 *
 * Пропускает кавычки, скобки, пробелы и любую пунктуацию: для имени
 * «ООО "Абрамсон"» вернёт `O`, для «"Ромашка"» — `Р`.
 *
 * Возвращает `'?'` если в строке нет ни одной буквы/цифры.
 */
export function pickAvatarInitial(value: string | null | undefined): string {
  if (!value) return '?';
  for (const ch of value) {
    if (/\p{L}|\p{N}/u.test(ch)) return ch.toUpperCase();
  }
  return '?';
}
